import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import { R } from '@core/utils/r';
import MFormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, { ChangeEvent, Fragment, useCallback, useMemo } from 'react';
import { FormGroup, FormGroupProps, Input, InputGroup, InputGroupAddon, InputGroupText, InputProps, Label, UncontrolledTooltip } from 'reactstrap';
import OtpInput from 'react-otp-input';

import './form_input.scss';

export interface FormInputOTPProps<C extends FormControl<any>> extends FieldProps<C> {
  autoFocus?: boolean;
  groupProps?: FormGroupProps;
  withoutGroup?: boolean;
  description?: string;
  container?: string;
  parseToFloat?: boolean;
  onText?(text: string): void;
  onFocusChange?(focused: boolean): void;
  flex?: number[];
  inputParentStyles?: React.CSSProperties;
}

export function FormInputOTP<C extends FormControl<any>>(props: FormInputOTPProps<C> & InputProps) {
  const { readonly, withoutGroup = false, onText, onFocusChange, icon, inputParentStyles, ...rest } = props;

  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = R.toString(fieldState.value) || '';
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const handleChange = useCallback(
    (value: string) => {
      formControl.setValue(value);
      onText && onText(value);
    },
    [formControl, onText],
  );

  const content = (
    <Fragment>
      <OtpInput
        inputStyle="inputStyle"
        onChange={handleChange}
        value={fieldValue}
        numInputs={6}
        renderSeparator={<span></span>}
        renderInput={props => <input {...props} />}
        shouldAutoFocus
      />

      {/* {!props.flex && !R.isEmpty(fieldValue) && !!fieldError && <FormHelperText style={{ color: '#f44336' }}>{fieldError}</FormHelperText>} */}
    </Fragment>
  );

  if (withoutGroup) return content;
  return (
    <FormGroup className={props.flex ? 'd-flex align-items-center' : ''} {...props.groupProps}>
      {content}
    </FormGroup>
  );
}
